import { motion } from "framer-motion";
import LogoMark from "./LogoMark";
import { EASE } from "./Reveal";

export default function Preloader() {
    return (
        <motion.div
            data-testid="preloader"
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505]"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.85, ease: EASE }}
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.7, ease: EASE }}
            >
                <LogoMark size={96} />
            </motion.div>
            <motion.p
                className="mt-6 font-display text-2xl tracking-[0.45em] text-white/90"
                initial={{ opacity: 0, letterSpacing: "0.2em" }}
                animate={{ opacity: 1, letterSpacing: "0.45em" }}
                transition={{ duration: 0.9, delay: 0.25, ease: EASE }}
            >
                TRAINER ARYAN
            </motion.p>
            <motion.div
                className="mt-5 h-px w-40 bg-gradient-to-r from-transparent via-[#F5C542] to-transparent"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.1, delay: 0.35, ease: EASE }}
            />
        </motion.div>
    );
}
